import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Translate } from "../../Enums/Tranlate";
import AdminService from "../../../services/AdminService";
import { usePermissions } from "../../common/permissions";
import dollar from "../../../images/icons/dollar.svg";
import totalAdminsIcon from "../../../images/icons/total-admins.svg";
import totalCars from "../../../images/icons/total-cars.svg";
import drive from "../../../images/icons/drive.svg";
import group from "../../../images/icons/group.svg";
import numOfCars from "../../../images/icons/numOfCars.svg";
import parkingZone from "../../../images/icons/parkingZone.svg";
import "./style.scss";

/**
 * Card definitions. `to` and `permission` let each tile double as a shortcut
 * into the module it summarises — and stay hidden when the admin can't view it.
 */
const CARDS = [
	{
		key: "totalIncome",
		label: "total_income",
		icon: dollar,
		tone: "income",
		suffix: "kwd",
		to: "/payment-report",
		permission: "payment_report",
	},
	{
		key: "totalParkings",
		label: "cars_services",
		icon: totalCars,
		tone: "parking",
		to: "/parking",
		permission: "parking",
	},
	{
		key: "totalQuickValet",
		label: "total_quick_valet",
		icon: numOfCars,
		tone: "valet",
		to: "/quick-valet",
		permission: "quick_valet",
	},
	{
		key: "totalLeaveParkings",
		label: "total_leave_parkings",
		icon: parkingZone,
		tone: "leave",
		to: "/requests",
		permission: "request",
	},
	{
		key: "totalZone",
		label: "total_zone",
		icon: parkingZone,
		tone: "zone",
		to: "/zones",
		permission: "zone",
	},
	{
		key: "totalDrivers",
		label: "total_drivers",
		icon: drive,
		tone: "driver",
		to: "/drivers",
		permission: "driver",
	},
	{
		key: "totalClient",
		label: "total_clients",
		icon: group,
		tone: "client",
		to: "/users",
		permission: "user",
	},
	{
		key: "totalAdmins",
		label: "total_admins",
		icon: totalAdminsIcon,
		tone: "admin",
		to: "/admins",
		permission: "admin",
	},
];

/** 1234.5 -> "1,234.5" so large counters stay readable. */
function formatValue(value) {
	if (value === null || value === undefined || value === "") return "0";
	const num = Number(value);
	if (Number.isNaN(num)) return `${value}`;
	return num.toLocaleString("en-US", { maximumFractionDigits: 3 });
}

const Dashboard = () => {
	const [formData, setFormData] = useState({});
	const [loading, setLoading] = useState(true);
	const lang = useSelector((state) => state.auth.lang);
	const navigate = useNavigate();
	const { canView } = usePermissions();

	const cards = CARDS.filter((card) => canView(card.permission));

	useEffect(() => {
		setLoading(true);
		new AdminService()
			.getDashboard()
			.then((res) => {
				if (res?.status) setFormData(res.data.data || {});
				setLoading(false);
			})
			.catch(() => setLoading(false));
	}, []);

	return (
		<div className="dashboard">
			<div className="dashboard-head">
				<h2>{Translate[lang]?.dashboard}</h2>
				<p>{Translate[lang]?.welcome_back}</p>
			</div>

			<div className="stat-grid">
				{loading
					? cards.map((card) => (
							<div className="stat-card is-loading" key={card.key}>
								<div className="stat-card__icon skeleton" />
								<div className="stat-card__body">
									<span className="skeleton skeleton-line short" />
									<span className="skeleton skeleton-line" />
								</div>
							</div>
					  ))
					: cards.map((card) => (
							<button
								type="button"
								className={`stat-card tone-${card.tone}`}
								key={card.key}
								onClick={() => card.to && navigate(card.to)}>
								<span className="stat-card__icon">
									<img src={card.icon} alt="" aria-hidden="true" />
								</span>
								<span className="stat-card__body">
									<span className="stat-card__label">
										{Translate[lang][card.label]}
									</span>
									<span className="stat-card__value">
										{formatValue(formData?.[card.key])}
										{card.suffix && (
											<small>{Translate[lang][card.suffix]}</small>
										)}
									</span>
								</span>
							</button>
					  ))}
			</div>
		</div>
	);
};

export default Dashboard;
